<template>
	<v-card>
		<v-card-text>
			<v-simple-table>
				<template v-slot:default>
					<thead>
						<tr>
							<th>{{ $t("Name") }}</th>
							<th style="width: 200px">
								{{ $t("Price") }}
							</th>
							<th width="80">
								<v-btn icon @click="addExtra()"
									><v-icon>mdi-plus</v-icon></v-btn
								>
							</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(extra, index) in extras" :key="index">
							<td>
								<app-localized-item-input-form
									v-model="extra.name"
									:label="$t('Name')"
								></app-localized-item-input-form>
							</td>

							<td>
								<v-text-field
									v-model="extra.price"
									type="number"
									prefix="+$ "
									:data-vv-name="`extra.${index}.price`"
								></v-text-field>
							</td>
							<td>
								<v-btn
									color="error"
									icon
									@click="removeExtra(index)"
									><v-icon>mdi-delete</v-icon></v-btn
								>
							</td>
						</tr>
					</tbody>
				</template>
			</v-simple-table>
		</v-card-text>
	</v-card>
</template>

<script>
export default {
	props: {
		value: {
			required: true,
			type: Array,
		},
	},

	computed: {
		extras: {
			get() {
				return this.value;
			},
			set(value) {
				this.$emit("input", value);
			},
		},
	},

	methods: {
		addExtra() {
			this.extras.push({});
		},

		removeExtra(index) {
			this.extras.splice(index, 1);
		},
	},
};
</script>